// extracted by mini-css-extract-plugin
export default {"subTitle":"PerformanceRanksModalHeader_subTitle__WIM+i"};